export const getVideoDurationFilterStyle = () => ({
  videoDurationFilterDowndown: {
    padding: 24,
    pointerEvents: 'auto',
  },

  dropdownTitle: {
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '20px',
  },

  dropdownValueInput: {
    marginTop: 21,
  },
});
